<template>
    <modal title="Link freigeben" ref="modal">
        <base-checkbox
            v-model="ispublic"
            id="ispublic"
            label="Linkfreigabe aktivieren"
            lines="none"
            info="Bei aktiver Linkfreigabe darf jeder im Internet die Datei über diesen Link ansehen."
            @click.native="shareFile()"
            :disabled="isShareDisabled"
        ></base-checkbox>
        <template v-slot:footer>
            <ion-button
                expand="block"
                fill="outline"
                color="primary"
                class="ion-margin-top"
                :disabled="!ispublic"
                @click="copyLink()"
            >
                <ion-icon name="copy" slot="start"></ion-icon>
                Link kopieren
            </ion-button>
            <ion-button
                expand="block"
                class="ion-margin-top"
                :disabled="!ispublic"
                @click="shareLink()"
            >
                <ion-icon name="share-alt" slot="start"></ion-icon>
                Link teilen
            </ion-button>
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import BaseCheckbox from "./BaseCheckbox";
import { shareFile, unshareFile } from "@/api/dokbox";
import { Plugins } from "@capacitor/core";
import { BASEURL } from "@/utils/globals";

const { Clipboard, Share } = Plugins;

export default {
    components: {
        Modal,
        BaseCheckbox,
    },
    props: {
        currentIndex: {
            required: true,
        },
    },
    data() {
        return {
            ispublic: false,
            isShareDisabled: false,
            link: "",
            baseurl: BASEURL,
        };
    },
    mounted() {
        if (this.currentIndex < this.$store.getters["dokbox/images"].length) {
            this.ispublic = this.$store.getters["dokbox/images"][
                this.currentIndex
            ].filePublic;
            this.link =
                this.baseurl +
                this.$store.getters["dokbox/images"][this.currentIndex].fileUrl;
        }
    },
    computed: {
        fileId() {
            let fileId = -1;
            if (
                this.currentIndex < this.$store.getters["dokbox/images"].length
            ) {
                fileId = this.$store.getters["dokbox/images"][this.currentIndex]
                    .fileId;
            }
            return fileId;
        },
    },
    methods: {
        shareFile() {
            this.isShareDisabled = true;
            this.$store.commit("setLoading", true);
            if (this.ispublic) {
                shareFile(
                    this.$store.getters["dokbox/images"][this.currentIndex]
                        .fileId
                )
                    .then((response) => {
                        if (response.data.Status === 200) {
                            this.link =
                                this.baseurl +
                                this.$store.getters["dokbox/images"][
                                    this.currentIndex
                                ].fileUrl;
                            this.$store.commit("dokbox/setFile", {
                                fileId: this.fileId,
                                filePublic: true,
                            });
                        } else {
                            this.ispublic = false;
                        }
                    })
                    .finally(() => {
                        this.isShareDisabled = false;
                    });
            } else {
                unshareFile(
                    this.$store.getters["dokbox/images"][this.currentIndex]
                        .fileId
                )
                    .then((response) => {
                        if (response.data.Status === 200) {
                            this.link = "";
                            this.$store.commit("dokbox/setFile", {
                                fileId: this.fileId,
                                filePublic: false,
                            });
                        } else {
                            this.ispublic = true;
                        }
                    })
                    .finally(() => {
                        this.isShareDisabled = false;
                    });
            }
        },
        copyLink() {
            Clipboard.write({ string: this.link }).then(() => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: "Link wurde kopiert",
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
        shareLink() {
            Share.share({
                url: this.link,
            }).catch((error) => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: error,
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
    },
};
</script>

<style></style>
